import { template as template_6d8e32c0a1264ccca59009e7fceaca42 } from "@ember/template-compiler";
import { dasherize } from '@ember/string';
import { eq } from 'ember-truth-helpers';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import BasicDropdown from 'ember-basic-dropdown/components/basic-dropdown';
import ClassOnScroll from 'client-portal/modifiers/class-on-scroll';
import Component from '@glimmer/component';
import RequestClinicianSearchFacetFilterContent from './facet-filter-content';
import RequestClinicianSearchFilterPillButton from './filter-pill-button';
import RequestClinicianSearchFilteredResultsSummary from './filtered-results-summary';
import RequestClinicianSearchMoreFiltersPillButton from './more-filters-pill-button';
import fitToViewportHeight from 'client-portal/modifiers/fit-to-viewport-height';
import fixedDropdownPosition from 'client-portal/utils/clinicianSearch/fixed-dropdown-position';
import styles from './filters-summary-bar.module.scss';
import t from 'ember-intl/helpers/t';
export default class RequestClinicianSearchFiltersSummaryBar extends Component {
    @service
    intl;
    @service
    media;
    @service
    clinicianSearch;
    @service
    router;
    @service
    session;
    styles = styles;
    calculateFixedPosition = fixedDropdownPosition;
    get rootClassNames() {
        let classNames = [
            styles.component
        ];
        if (this.session.currentClient) {
            classNames.push('signed-in');
        }
        if (!this.clinicianSearch.mobile.isHeaderVisible) {
            classNames.push('mobile-header-hidden');
        }
        return classNames.join(' ');
    }
    get filterScrollShadowThreshold() {
        return this.isWidgetRoute ? 50 : this.media.isMdDown ? 16 : 160;
    }
    get filterScrollElementSelector() {
        return this.isWidgetRoute ? '.content' : null;
    }
    get isWidgetRoute() {
        return this.router.currentRouteName.startsWith('widget.');
    }
    get filterItems() {
        return this.clinicianSearch.facetNames.names.map((key)=>({
                key
            }));
    }
    toggleFilterOverlay = (event)=>{
        event?.preventDefault?.();
        this.clinicianSearch.mobile.toggleFiltersOverlay();
    };
    dropdownBodyClass = (key)=>[
            'pill-dropdown-body',
            'clinician-search-dropdown-body',
            'clinician-search-pill-body',
            `clinician-search-pill-body-${dasherize(key)}`
        ].join(' ');
    openFilterPillAriaLabel = (facetKey)=>this.intl.t('booking.clinicianSearch.filterDetail.openFilterPillAria', {
            filterLabel: this.clinicianSearch.facetNames.baseLabel(facetKey)
        });
    onFilterDropdownOpen = (filterType)=>{
        this.clinicianSearch.trackFilterTypeSelected(filterType);
    };
    static{
        template_6d8e32c0a1264ccca59009e7fceaca42(`
    <div
      class={{this.rootClassNames}}
      data-test-clinician-search-filters-summary-bar
      {{ClassOnScroll
        scrollTarget=this.filterScrollShadowThreshold
        scrollElementSelector=this.filterScrollElementSelector
      }}
    >
      <div class="filters-summary-inner">
        <section class="filters-bar" data-test-clinician-search-filter-bar>
          <div class="filters-pills" data-test-clinician-search-filters>
            <div class="filters-desktop">
              {{#each this.filterItems as |filter|}}
                <BasicDropdown
                  class="pill-dropdown"
                  @destination="modal-destination"
                  @horizontalPosition="auto"
                  @verticalPosition="below"
                  @calculatePosition={{this.calculateFixedPosition}}
                  @onOpen={{fn this.onFilterDropdownOpen filter.key}}
                  data-test-clinician-search-filter={{filter.key}}
                  as |dd|
                >
                  <dd.Trigger
                    class="pill-dropdown-trigger-host"
                    aria-haspopup="dialog"
                    aria-label={{this.openFilterPillAriaLabel filter.key}}
                  >
                    {{#if (eq filter.key "moreFilters")}}
                      <RequestClinicianSearchMoreFiltersPillButton
                        @isLoading={{@isLoading}}
                        @facetName={{filter.key}}
                      />
                    {{else}}
                      <RequestClinicianSearchFilterPillButton
                        @isLoading={{@isLoading}}
                        @facetName={{filter.key}}
                      />
                    {{/if}}
                  </dd.Trigger>
                  <dd.Content class="pill-dropdown-floating-content">
                    <div
                      class={{this.dropdownBodyClass filter.key}}
                      data-test-clinician-search-pill-body={{filter.key}}
                      {{fitToViewportHeight max=624 bottomBuffer=24}}
                    >
                      <RequestClinicianSearchFacetFilterContent @facetName={{filter.key}} />
                    </div>
                  </dd.Content>
                </BasicDropdown>
              {{/each}}
            </div>

            <div class="filters-trigger-wrap">
              <button
                type="button"
                class="filters-pill-button"
                aria-haspopup="dialog"
                aria-expanded={{this.clinicianSearch.mobile.isFiltersOverlayOpen}}
                aria-controls="clinician-search-mobile-filters"
                data-test-clinician-search-filters-open
                {{on "click" this.toggleFilterOverlay}}
              >
                {{t "booking.clinicianSearch.openFiltersPill"}}
              </button>
            </div>
          </div>
        </section>

        <RequestClinicianSearchFilteredResultsSummary
          class="toolbar-filtered-summary-narrow-only"
          @meta={{@meta}}
          @isLoading={{@isLoading}}
        />
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
